import configDataFn from '@/baseData/personalOrder/manageList'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function () {
  const jumpDetail = (query) => {
    query.orderType = 'personal'
    this.$router.push({
      path: '/workbench/rentOrder/detail',
      query,
    })
  }

  // 客户名称模糊搜索loading
  let loading = false
  // 车牌号&客户名称模糊搜索
  const remoteMethod = async (query) => {
    if (query.length >= 4) {
      // 车牌号
      // 开启远程搜索
      loading = true
      const { code, data } = await FuzzySearch({
        state: 1,
        plateNo: query,
      })
      if (code === 1) {
        // 关闭远程搜索
        loading = false
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'carId',
          data,
        })
      }
    } else {
      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'list',
        key: 'carId',
        data: [],
      })
    }
  }

  const formData = [
    {
      el: 'select',
      itemConfig: {
        label: '车牌号',
        prop: 'carId',
      },
      elConfig: {
        filterable: true,
        remote: true,
        'reserve-keyword': true,
        placeholder: '请输入',
        'remote-method': remoteMethod,
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
        events: {
          change: () => {
            const carIdItem = this.configData.formData.list.find((item) => item.itemConfig.prop === 'carId')
            this.carConditionList = carIdItem?.elConfig?.options?.list
          },
        },
      },
    },
    {
      el: 'CarBrandSeriesModel',
      itemConfig: {
        prop: 'brandSeriesModel',
        ref: 'brandSeriesModelRef',
      },
      elConfig: {
        showModel: true,
        filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
      },
      render: 'CarBrandSeriesModel',
    },
  ]

  const diffTableData = [
    {
      name: 'plateNo',
      columnProps: {
        prop: 'plateNo',
        label: '车牌号',
        width: 100,
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
    },
    {
      name: 'brandName',
      columnProps: {
        prop: 'brandName',
        label: '品牌',
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        prop: 'seriesName',
        label: '车系',
      },
    },
    {
      name: 'modelName',
      columnProps: {
        prop: 'modelName',
        label: '车型',
        width: 160,
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
    },
  ]
  const operate = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    type: 'operate',
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      const arr = [
        {
          label: '详情',
          action: () =>
            jumpDetail({
              id: row.id,
              tabType: 'personalOrder',
            }),
        },
      ]
      return arr
    },
  }

  const { configData } = configDataFn.call(this, {
    bizType: 10,
    tabNo: 0,
    dealWithData: this.dealWithData,
  })
  configData.formData.list = [...formData, ...configData.formData.list]
  configData.formData.customizeReset = () => {
    this.$refs.baseListManagement.setItemData({
      elConfigKey: 'value',
      key: 'brandSeriesModel',
      data: {},
    })
  }
  configData.tableData.columns.splice(1, 0, ...diffTableData)
  configData.tableData.columns.push(operate)
  return { configData }
}
